<p-panel header="Fehler">
  <p>
    <i class="pi pi-exclamation-triangle"></i> Es ist ein Fehler aufgetreten.
  </p>
</p-panel>
